import { useState, useEffect } from 'react';

interface SliderCaptchaProps {
  onVerify: (verified: boolean) => void;
  reset?: boolean;
}

export default function SliderCaptcha({ onVerify, reset }: SliderCaptchaProps) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (reset) {
      setChecked(false);
      onVerify(false);
    }
  }, [reset, onVerify]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.checked;
    setChecked(val);
    onVerify(val);
  };

  return (
    <label
      className="flex items-center gap-3 h-11 px-4 rounded-lg border border-gray-200 bg-[#f9fafb] cursor-pointer select-none w-full"
    >
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          className="w-5 h-5 accent-emerald-500 cursor-pointer"
        />
      </div>
      <span className="text-sm text-gray-600 font-medium">
        {checked ? (
          <span className="text-emerald-600 font-semibold flex items-center gap-1">
            <i className="ri-check-line" /> Verified
          </span>
        ) : (
          "I'm not a robot"
        )}
      </span>
      <div className="ml-auto flex items-center gap-1 opacity-40">
        <i className="ri-shield-check-line text-gray-400 text-lg" />
      </div>
    </label>
  );
}